import _extends from "@babel/runtime/helpers/extends";
import React, { lazy } from "react";

// Digital Menu
var DigitalMenuBannerTop = lazy(() => import("./DigitalMenuBannerTop"));

// Mission components
var MissionText = lazy(() => import("./Mission/Text"));
var MissionImage = lazy(() => import("./Mission/Image"));
var MissionDiscover = lazy(() => import("./Mission/Discover"));
var MissionStats = lazy(() => import("./Mission/Stats"));
var MissionCarousel = lazy(() => import("./Mission/missionCarousel"));
var MissionCtaPdf = lazy(() => import("./Mission/CtaPdf"));
var MissionVideo = lazy(() => import("./Mission/MissionVideo"));
var MissionLandingPage = lazy(() => import("./Mission/MissionLandingPage"));
var MissionCtaButton = lazy(() => import("./Mission/CtaButton"));

// Stores components
var StoresBoxText = lazy(() => import("./Stores/boxText"));
var StoresBoxImageMiddle = lazy(() => import("./Stores/boxImageMiddle"));
var StoresSlider = lazy(() => import("./Stores/sliderStores"));
var StoresTopCarousel = lazy(() => import("./Stores/topCarousel"));
var StoresBannerHeader = lazy(() => import("./Stores/bannerHeader"));
var AllStoresCarousel = lazy(() => import("./Stores/allStoresCarousel"));
var StoresEvents = lazy(() => import("./Stores/event"));
var StoresContactUs = lazy(() => import("./Stores/contactUs"));

// Product detail components
var ProductPageBannerTop = lazy(() => import("./ProductDetail/productPageBannerTop"));
var ProductPageSiAbbinaConTutto = lazy(() => import("./ProductDetail/ProductPageSiAbbinaConTutto"));
var ProductPageBannerMiddle = lazy(() => import("./ProductDetail/productPageBannerMiddle"));
var ProductPageBannerMiddle2 = lazy(() => import("./ProductDetail/ProductPageBannerMiddle2"));
var ProductPageBannerMiddle3 = lazy(() => import("./ProductDetail/productPageBannerMiddle3"));

// Homepage components
var Presignature = lazy(() => import("./Homepage/presignature"));
var HomepageBannerMiddle = lazy(() => import("./Homepage/bannerMiddle"));
var HomepageBannerMiddleSingleImage = lazy(() => import("./Homepage/bannerMiddleSingleImage"));
var HomepageBannerImageMiddle = lazy(() => import("./Homepage/bannerImageMiddle"));
var HomepageCarbs = lazy(() => import("./Homepage/carbs"));
var HomepageSliderFull = lazy(() => import("./Homepage/sliderTop"));
var HomepageEventDetails = lazy(() => import("./Homepage/eventDetails"));

// Covid components
var CovidBannerTopPage = lazy(() => import("./Covid/bannerTopPage"));
var CovidTextImages = lazy(() => import("./Covid/textImages"));
var CovidBollini = lazy(() => import("./Covid/bollini"));
var CovidMiddleCarousel = lazy(() => import("./Covid/middleCarousel"));
var CovidBolliniBottom = lazy(() => import("./Covid/bolliniBottom"));
var CovidBottomCarousel = lazy(() => import("./Covid/bottomCarousel"));
var CovidBottomLink = lazy(() => import("./Covid/bottomLink"));

// Makers components
var MakersMenuBannerTop = lazy(() => import("./Produttori/menuBannerTop"));
var MakersPartnersIcons = lazy(() => import("./Produttori/partnersIcons"));
var MakersFooterContactUs = lazy(() => import("./Produttori/footerContactUs"));

// Our Challenge components
var OurChallengeHeader = lazy(() => import("./OurChallengeDetail/ourChallengeHeader"));
var OurChallengeBannerHeader = lazy(() => import("./OurChallenge/OurChallengeBannerHeader"));
var OurChallengeTargets = lazy(() => import("./OurChallenge/Targets"));
var OurChallengeOtherSections = lazy(() => import("./OurChallenge/OurChallengeOtherSections"));
var OurChallengeRedSlider = lazy(() => import("./OurChallenge/RedSlider"));
var OurChallengeMenuChoices = lazy(() => import("./OurChallenge/OurChallengeMenuChoices"));
var OurChallengeBannerLeftText = lazy(() => import("./OurChallenge/OurChallengeBannerLeftText"));

// Loyalty components
var LoyaltyBannerHeader = lazy(() => import("./Loyalty/LoyaltyBannerHeader"));
var LoyaltyBannerSeed = lazy(() => import("./Loyalty/LoyaltyBannerSeed"));
var LoyaltyRedSlider = lazy(() => import("./Loyalty/LoyaltyRedSlider"));
var LoyaltyTargets = lazy(() => import("./Loyalty/LoyaltyTargets"));
var LoyaltyOtherSections = lazy(() => import("./Loyalty/LoyaltyOtherSections"));

// Farm components
var FarmBannerTop = lazy(() => import("./Farm/farmBannerTop"));

// Blog components
var BlogHomeCategory = lazy(() => import("./Blog/HomeCategory"));
var BlogMoreRead = lazy(() => import("./Blog/BlogMoreRead"));
var BlogDetailText = lazy(() => import("./BlogDetail/BlogDetailText"));
var BlogDetailVideo = lazy(() => import("./BlogDetail/BlogDetailVideo"));
var BlogDetailCarousel = lazy(() => import("./BlogDetail/BlogDetailCarousel"));
var BlogDetailOtherPosts = lazy(() => import("./BlogDetail/BlogDetailOtherPosts"));
var MostPopular = lazy(() => import("./BlogCategory/MostPopular"));
var BlogDetailSingleImage = lazy(() => import("./BlogDetail/BlogDetailSingleImage"));

// Product takeaway components
var ProductPageInfoExtra = lazy(() => import("./ProductTakeaway/ProductPageInfoExtra"));

// Career components
var CareerTopBanner = lazy(() => import("./careerWidget/careerTopBanner"));
var CareerTopAnnunci = lazy(() => import("./careerWidget/careerTopAnnunci"));
var CareerCarousel = lazy(() => import("./careerWidget/careerCarousel"));
var CareerReasons = lazy(() => import("./careerWidget/careerReasons"));
var CareerStories = lazy(() => import("./careerWidget/careerStories"));
var CareerHREFs = lazy(() => import("./careerWidget/careerHREFs"));

// Events components
var EventsTopBanner = lazy(() => import("./Events/eventsBannerHeader"));
var SingleEventBanner = lazy(() => import("./Events/singleEventBanner"));
var EventsRedSlider = lazy(() => import("./Events/eventsRedSlider"));
var EventMultipleCategoriesChooser = lazy(() => import("./Events/eventMultipleCategoriesChooser"));

// Event Details components
var EventDetailsTopBanner = lazy(() => import("./EventDetails/eventDetailsTopBanner"));
var EventDetailsVideo = lazy(() => import("./EventDetails/eventDetailsVideo"));
var EventCarousel = lazy(() => import("./EventDetails/eventCarousel"));
var EventDetailsScaletta = lazy(() => import("./EventDetails/eventDetailsScaletta"));
var EventDetailsButton = lazy(() => import("./EventDetails/eventDetailsButton"));
var EventDetailsFooter = lazy(() => import("./EventDetails/eventDetailsFooter"));
var EventDetailsCarouselContatto = lazy(() => import("./EventDetails/eventDetailsCarouselContatto"));

// Product page CMS components
var ProductPageCMSImagePlusCTA = lazy(() => import("./ProductPageCMSImagePlusCTA/productPageCMSImagePlusCTA"));

// This is the component that renders widgets
/**
 *
 * @param {{
 *  metadata_json:string,
 *  widget_type:string,
 *  category: any,
 *  hideCategory?: boolean
 * }} props
 * @returns {React.ReactNode}
 */
export default function Widget(_ref) {
  var {
    metadata_json,
    widget_type,
    category,
    hideCategory,
    isEventContatto,
    eventCode,
    eventName,
    eventId
  } = _ref;
  var Component = null;
  switch (widget_type) {
    case "Reply\\Widgets\\Block\\Widget\\DigitalMenuBannerTop":
      Component = DigitalMenuBannerTop;
      break;
    case "Reply\\Mission\\Block\\Widget\\Text":
      Component = MissionText;
      break;
    case "Reply\\Mission\\Block\\Widget\\Image":
      Component = MissionImage;
      break;
    case "Reply\\Mission\\Block\\Widget\\Discover":
      Component = MissionDiscover;
      break;
    case "Reply\\Mission\\Block\\Widget\\Stats":
      Component = MissionStats;
      break;
    case "Reply\\Mission\\Block\\Widget\\Carousel":
      Component = MissionCarousel;
      break;
    case "Reply\\Mission\\Block\\Widget\\CTAButtonDownload":
      Component = MissionCtaPdf;
      break;
    case "Reply\\Mission\\Block\\Widget\\Video":
      Component = MissionVideo;
      break;
    case "Reply\\Mission\\Block\\Widget\\Landing":
      Component = MissionLandingPage;
      break;
    case "Reply\\Mission\\Block\\Widget\\CTAButton":
      Component = MissionCtaButton;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTATop":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTAMiddle":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBannerTestoImmagineSfondo":
      Component = StoresBoxImageMiddle;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTABottom":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiCarouselMiddle":
      Component = StoresSlider;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiCarouselTop":
      Component = StoresTopCarousel;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBannerTopImgTitle":
      Component = StoresBannerHeader;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBoxTitoloTestoCTATop":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageCarousel":
      Component = AllStoresCarousel;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageEvents":
      Component = StoresEvents;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBannerTestoSfondo":
      Component = StoresContactUs;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerTop":
      Component = ProductPageBannerTop;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageInfoExtraSiAbbinaConTutto":
      Component = ProductPageSiAbbinaConTutto;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddleTopBottomImage":
      Component = ProductPageBannerMiddle2;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddle2TopImage":
      Component = ProductPageBannerMiddle;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddle3LeftRightImageText":
      Component = ProductPageBannerMiddle3;
      break;
    case "Reply\\Homepage\\Block\\Widget\\Presignature":
      Component = Presignature;
      break;
    case "Reply\\Homepage\\Block\\Widget\\CucinaTuDoppia":
      Component = HomepageBannerMiddle;
      break;
    case "Reply\\Homepage\\Block\\Widget\\CucinaTuSingola":
      Component = HomepageBannerMiddleSingleImage;
      break;
    case "Reply\\Homepage\\Block\\Widget\\BannerImageMiddle":
      Component = HomepageBannerImageMiddle;
      break;
    case "Reply\\Homepage\\Block\\Widget\\Carbs":
      Component = HomepageCarbs;
      break;
    case "Reply\\Homepage\\Block\\Widget\\HomeTopCarousel":
      Component = HomepageSliderFull;
      break;
    case "Reply\\Homepage\\Block\\Widget\\EventLS":
      Component = HomepageEventDetails;
      break;
    case "Reply\\Covid\\Block\\Widget\\TopPage":
      Component = CovidBannerTopPage;
      break;
    case "Reply\\Covid\\Block\\Widget\\TextImages":
      Component = CovidTextImages;
      break;
    case "Reply\\Covid\\Block\\Widget\\BolliniMiddleTop":
      Component = CovidBollini;
      break;
    case "Reply\\Covid\\Block\\Widget\\MiddleCarousel":
      Component = CovidMiddleCarousel;
      break;
    case "Reply\\Covid\\Block\\Widget\\BolliniMiddleBottom":
      Component = CovidBolliniBottom;
      break;
    case "Reply\\Covid\\Block\\Widget\\BottomCarousel":
      Component = CovidBottomCarousel;
      break;
    case "Reply\\Mission\\Block\\Widget\\Bottom":
      Component = CovidBottomLink;
      break;
    case "Reply\\Maker\\Block\\Widget\\MakerMenuBannerTop":
      Component = MakersMenuBannerTop;
      break;
    case "Reply\\Maker\\Block\\Widget\\PartnersIcons":
      Component = MakersPartnersIcons;
      break;
    case "Reply\\Maker\\Block\\Widget\\FooterContactUs":
      Component = MakersFooterContactUs;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\Hotspot":
      Component = OurChallengeHeader;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\BannerTop":
      Component = OurChallengeBannerHeader;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\BannerLeftText":
      Component = OurChallengeBannerLeftText;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\RedSlider":
      Component = OurChallengeRedSlider;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\Targets":
      Component = OurChallengeTargets;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\MenuChoices":
      Component = OurChallengeMenuChoices;
      break;
    case "Reply\\OurChallenge\\Block\\Widget\\OtherSections":
      Component = OurChallengeOtherSections;
      break;
    case "Reply\\Loyalty\\Block\\Widget\\BannerTop":
      Component = LoyaltyBannerHeader;
      break;
    case "Reply\\Loyalty\\Block\\Widget\\BannerSeed":
      Component = LoyaltyBannerSeed;
      break;
    case "Reply\\Loyalty\\Block\\Widget\\RedSlider":
      Component = LoyaltyRedSlider;
      break;
    case "Reply\\Loyalty\\Block\\Widget\\Targets":
      Component = LoyaltyTargets;
      break;
    case "Reply\\Loyalty\\Block\\Widget\\OtherSections":
      Component = LoyaltyOtherSections;
      break;
    case "Reply\\Farm\\Block\\Widget\\BannerTop":
      Component = FarmBannerTop;
      break;
    case "Reply\\Blog\\Block\\Widget\\HomeCategory":
      Component = BlogHomeCategory;
      break;
    case "Reply\\Blog\\Block\\Widget\\MostRead":
      Component = BlogMoreRead;
      break;
    case "Reply\\Blog\\Block\\Widget\\Text":
      Component = BlogDetailText;
      break;
    case "Reply\\Blog\\Block\\Widget\\Video":
      Component = BlogDetailVideo;
      break;
    case "Reply\\Blog\\Block\\Widget\\Carousel":
      Component = BlogDetailCarousel;
      break;
    case "Reply\\Blog\\Block\\Widget\\OtherPosts":
      Component = BlogDetailOtherPosts;
      break;
    case "Reply\\Blog\\Block\\Widget\\ImmagineSingola":
      Component = BlogDetailSingleImage;
      break;
    case "Reply\\Blog\\Block\\Widget\\MostPopular":
      Component = MostPopular;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageInfoExtra":
      Component = ProductPageInfoExtra;
      break;
    case "Reply\\WorkWithUs\\Block\\Widget\\TopBanner":
      Component = CareerTopBanner;
      break;
    case "Reply\\WorkWithUs\\Block\\Widget\\TopAnnunci":
      Component = CareerTopAnnunci;
      break;
    case "Reply\\WorkWithUs\\Block\\Widget\\Carousel":
      Component = CareerCarousel;
      break;
    case "Reply\\WorkWithUs\\Block\\Widget\\Reasons":
      Component = CareerReasons;
      break;
    case "Reply\\WorkWithUs\\Block\\Widget\\Stories":
      Component = CareerStories;
      break;
    case "Reply\\WorkWithUs\\Block\\Widget\\BlocksHREFs":
      Component = CareerHREFs;
      break;
    case "Reply\\Event\\Block\\Widget\\TopBanner":
      Component = EventsTopBanner;
      break;
    case "Reply\\Event\\Block\\Widget\\SingleEventBanner":
      Component = SingleEventBanner;
      break;
    case "Reply\\Event\\Block\\Widget\\ThreeEventsBanner":
      Component = EventsRedSlider;
      break;
    case "Reply\\Event\\Block\\Widget\\EventMultipleEventContattoChooser":
      Component = EventMultipleCategoriesChooser;
      break;
    case "Reply\\Event\\Block\\Widget\\TopBannerEventDetail":
      Component = EventDetailsTopBanner;
      break;
    case "Reply\\Event\\Block\\Widget\\EventDetailVideo":
      Component = EventDetailsVideo;
      break;
    case "Reply\\Event\\Block\\Widget\\EventDetailCarousel":
      Component = EventCarousel;
      break;
    case "Reply\\Event\\Block\\Widget\\EventDetailScaletta":
      Component = EventDetailsScaletta;
      break;
    case "Reply\\Event\\Block\\Widget\\EventDetailFooterCTA":
      Component = EventDetailsButton;
      break;
    case "Reply\\Event\\Block\\Widget\\EventDetailFooterBanner":
      Component = EventDetailsFooter;
      break;
    case "Reply\\Event\\Block\\Widget\\EventDetailCosaSiImpara":
      Component = EventDetailsCarouselContatto;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageCMSImagePlusCTA":
      Component = ProductPageCMSImagePlusCTA;
      break;
    default:
      return null;
  }
  var metadata = JSON.parse(metadata_json);

  // Pass the parsed JSON as props to the right component
  return /*#__PURE__*/React.createElement(Component, _extends({
    category: category,
    isEventContatto: isEventContatto,
    eventCode: eventCode,
    eventName: eventName,
    eventId: eventId
  }, metadata, {
    hideCategory
  }));
}